
const baseFavoriteyUrl = "Favorite"
const baseAdvertUrl = "Advert"
const baseCategoryUrl = "Category"
const baseGeneralUrl = "General"


  const endpoints = {
  
   addAdvertToFavorite:`${baseFavoriteyUrl}/AddToFavorite`,
   addAdvertToAlarm:`${baseAdvertUrl}/AddAlarmByAdvert`,
   updateAlarmItem:`${baseAdvertUrl}/UpdateAlarmByAdvert`,
   getAdvertDetails:`${baseAdvertUrl}`,
   getAdvertDetailsByNo:`${baseAdvertUrl}`,
   sendMessage:`${baseAdvertUrl}/SendMessage`,
   getCategoryTreeById:`${baseCategoryUrl}/GetAllCategoryRouteById`,
   getCategoryTreeByFilter:`${baseCategoryUrl}/GetCategoryTreeByUrl`,
    getCategoryById:`${baseCategoryUrl}`,
   getCategoryTreeFindId:`${baseCategoryUrl}/GetAllCategoryRouteById`,
   getNearbyPlaces:`${baseGeneralUrl}/GetNearbyPlaces`,

  };
  
  export default endpoints;